import { render } from "./PaladiumIcon.vue?vue&type=template&id=cf661ce6&ts=true"
import script from "./PaladiumIcon.vue?vue&type=script&lang=ts"
export * from "./PaladiumIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__